export default {
  render(parsed) {
    // build new topic data from original-post data
    const { info } = parsed;
    const data = {};
    data.title = `${parsed.threadname} by ${parsed.username}`;
    data.tags = ['leech'];
    data.content = '\n' +
      `**[%(blue)[${parsed.username}]](${parsed.userpage})**\n` +
      `*Join date: ${parsed.userJoinDate}*\n` +
      `*Number of posts: ${parsed.userNumOfPosts}*\n` +
      `[**${parsed.threadname}**](${info.url})\n` +
      `Posted at: ${parsed.postTimestamp}\n` +
      `\n---\n${parsed.postContent}`;
    return data;
  },
};
